import { createAction, props, union } from '@ngrx/store';
import { PayrollExtraEntry, CreatePayrollExtraEntry, DeletePayrollExtraInput } from 'app/api/payroll.extra.api.service';
import { PayrollExtraQuery } from '../payroll.types';

const source = 'payrollExtra';
const actions = 'api';

export const payrollExtraRequested = createAction(
    `[${source}][${actions}] PayrollExtra requested`,
    props<{ query: PayrollExtraQuery }>()
);
export const payrollExtraLoaded = createAction(
    `[${source}][${actions}] PayrollExtra loaded`,
    props<{ entries: PayrollExtraEntry[] }>()
);
export const payrollExtraCreateRequested = createAction(
    `[${source}][${actions}] PayrollExtra create requested`,
    props<{ input: CreatePayrollExtraEntry }>()
);
export const payrollExtraCreated = createAction(
    `[${source}][${actions}] PayrollExtra created`,
    props<{ input: PayrollExtraEntry }>()
);
export const payrollExtraRemoveOneRequested = createAction(
    `[${source}][${actions}] PayrollExtra remove one requested`,
    props<{ input: DeletePayrollExtraInput }>()
);
export const payrollExtraRemoved = createAction(
    `[${source}][${actions}] PayrollExtra entry removed`,
    props<{ input: DeletePayrollExtraInput }>()
);
export const payrollExtraUpdateOneRequested = createAction(
    `[${source}][${actions}] PayrollExtra update one requested`,
    props<{ input: PayrollExtraEntry }>()
);
export const payrollExtraUpdated = createAction(
    `[${source}][${actions}] PayrollExtra entry updated`,
    props<{ input: PayrollExtraEntry }>()
);
export const payrollExtraCancelled = createAction(
    `[${source}][${actions}] PayrollExtra cancelled`,
    props<{ errorMessage: string }>()
);

export const payrollExtraRemoveAll = createAction(
    `[${source}][${actions}] PayrollExtra Remove all`
);

const all = union({
    payrollExtraRequested,
    payrollExtraLoaded,
    payrollExtraCancelled,
    payrollExtraRemoveAll,
    payrollExtraCreateRequested,
    payrollExtraRemoved,
    payrollExtraRemoveOneRequested,
    payrollExtraUpdated,
    payrollExtraUpdateOneRequested
});

export type payrollExtraActionsUnion = typeof all;
